const MuiVerifiedTooltip = () => {
	return (
		<div className="w-[255px] py-1">
			<div className="">
				<p className="font-inter text-[13px] font-[600] text-white">Verified Account</p>
			</div>
			<div className="max-w-full font-inter mt-1">
				<p className="text-left">Recruiters give more priority to verified accounts </p>
			</div>
		</div>
	);
};

export default MuiVerifiedTooltip;
